import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const LogoComete = ({ sx }) => (
  <Box id="logo-comete" sx={{ minWidth: 24, minHeight: 24, ...sx }} alt="Logo Comète">
    <svg
      version="1.1"
      id="comete-logo"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 208.9 45.2"
      style={{ enableBackground: 'new 0 0 208.9 45.2' }}
    >
      <style>{`.st01{fill:url(#SVGID_1_);} .st11{fill:#23427C;}`}</style>
      <g>
        <radialGradient
          id="SVGID_1_"
          cx="39.7863"
          cy="14.6824"
          r="63.7427"
          fx="-23.956"
          fy="14.4819"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style={{ stopColor: '#FEEB17' }} />
          <stop offset="0.7358" style={{ stopColor: '#F8BF01' }} />
        </radialGradient>
        <path
          className="st01"
          d="M61.5,14.7L25.3,0L41,35.7c2.6,5.8,8.4,9.6,14.7,9.5c8.8-0.1,15.7-7.3,15.6-16.1C71.3,22.7,67.4,17,61.5,14.7z
		 M56,40.2c-4.2,0.1-7.9-2.4-9.6-6.2L36.1,10.7l23.6,9.6c3.9,1.6,6.4,5.3,6.5,9.4C66.3,35.4,61.7,40.1,56,40.2z"
        />
        <g>
          <path
            className="st11"
            d="M15.6,44.6c-4.5,0-8.2-1.5-11.1-4.5C1.5,37.1,0,33.4,0,29c0-4.4,1.5-8.1,4.4-11.1c3-3,6.7-4.5,11.1-4.5
			c2.9,0,5.5,0.7,7.9,2.1c2.3,1.4,4.1,3.3,5.2,5.7l-4.3,2.5c-0.7-1.6-1.9-2.8-3.5-3.8c-1.6-0.9-3.3-1.4-5.3-1.4c-3,0-5.4,1-7.4,3
			c-2,2-3,4.5-3,7.5c0,3,1,5.4,3,7.5c2,2,4.5,3,7.4,3c2,0,3.7-0.5,5.3-1.4c1.6-0.9,2.8-2.2,3.6-3.8l4.4,2.5
			c-1.3,2.3-3.1,4.2-5.4,5.6C21.1,43.9,18.5,44.6,15.6,44.6z"
          />
          <path
            className="st11"
            d="M130.3,31.4c0.5,2.6,1.7,4.7,3.6,6.2c1.9,1.5,4.3,2.2,7.1,2.2c3.9,0,6.7-1.4,8.5-4.3l4.4,2.5
			c-2.9,4.5-7.2,6.7-13,6.7c-4.7,0-8.5-1.5-11.5-4.4c-2.9-2.9-4.4-6.7-4.4-11.2c0-4.5,1.4-8.2,4.3-11.1c2.9-3,6.6-4.4,11.2-4.4
			c4.3,0,7.9,1.5,10.6,4.6c2.7,3.1,4.1,6.7,4.1,11c0,0.8-0.1,1.5-0.2,2.3H130.3z M140.6,18.3c-2.8,0-5.1,0.8-6.9,2.3
			c-1.8,1.6-2.9,3.6-3.4,6.2h19.8c-0.4-2.8-1.5-4.9-3.3-6.4C145,19,142.9,18.3,140.6,18.3z M144.2,10.1h-5l-6-7.8h6.2L144.2,10.1z"
          />
          <path
            className="st11"
            d="M176.1,19.2h-7.9v16c0,1.5,0.3,2.5,0.9,3.1c0.6,0.6,1.5,0.9,2.6,0.9c1.2,0,2.6,0,4.4-0.1v4.6
			c-4.5,0.6-7.8,0.2-9.9-1.1c-2.1-1.3-3.1-3.8-3.1-7.5v-16h-5.9v-5h5.9V7.5l5.2-1.5v8.3h7.9V19.2z"
          />
          <path
            className="st11"
            d="M183.9,31.4c0.5,2.6,1.7,4.7,3.6,6.2c1.9,1.5,4.3,2.2,7.1,2.2c3.9,0,6.7-1.4,8.5-4.3l4.4,2.5
			c-2.9,4.5-7.2,6.7-13,6.7c-4.7,0-8.5-1.5-11.5-4.4c-2.9-2.9-4.4-6.7-4.4-11.2c0-4.5,1.4-8.2,4.3-11.1c2.9-3,6.6-4.4,11.2-4.4
			c4.3,0,7.9,1.5,10.6,4.6c2.7,3.1,4.1,6.7,4.1,11c0,0.8-0.1,1.5-0.2,2.3H183.9z M194.2,18.3c-2.8,0-5.1,0.8-6.9,2.3
			c-1.8,1.6-2.9,3.6-3.4,6.2h19.8c-0.4-2.8-1.5-4.9-3.3-6.4C198.6,19,196.5,18.3,194.2,18.3z"
          />
        </g>
        <path
          className="st11"
          d="M114.8,43.8V25.6c0-3.8-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9v18.2h-5.1l0-18.2c0-3.8-3.1-6.9-6.9-6.9
		c-3.8,0-6.9,3.1-6.9,6.9v18.2h-5.1l0-18.6c0-6.6,5.4-12.1,12.1-12.1c3.4,0,6.7,1.5,9,4l0.5,0.6l0.5-0.6c2.3-2.5,5.6-4,9-4
		c6.6,0,12.1,5.4,12.1,12.1v18.6H114.8z"
        />
      </g>
    </svg>
  </Box>
);

LogoComete.propTypes = {
  sx: PropTypes.object
};

export default LogoComete;
